import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=152965a8&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
import style0 from "./Privacy.vue?vue&type=style&index=0&id=152965a8&prod&scoped=true&lang=css"
import style1 from "./Privacy.vue?vue&type=style&index=1&id=152965a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152965a8",
  null
  
)

export default component.exports